<template>
    <div class="shareExperience">
        <!-- 1-3选项跳转 -->
        <div class="step_title">
            <p><span>Step 4 of 4:</span> Confirm Your Address</p>
             <el-progress :text-inside="true" :stroke-width="24" :percentage="99" status="success"></el-progress>
        </div>
         <p style="margin-left: 265px;font-size:20px;color: #747474;">We will ship the free gift to:</p>
        <div class="post-content">
            <div class="post-content-left">
                <div class="fusion-title">{{title}}</div>
                <img :src="image" alt="" style="width: 200px;">
            </div>
            <el-card class="box-card">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-width="auto"  label-position="top">
                    <el-form-item label="Full Name" prop="name">
                           <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Address" prop="address">
                         <el-input type="textarea" v-model="ruleForm.address"></el-input>
                    </el-form-item>
                    <el-form-item label="phone">
                           <el-input v-model="ruleForm.phone" @change="getValue"></el-input>
                    </el-form-item>
                    <el-form-item label="Email" prop="email">
                           <el-input v-model="ruleForm.email"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="submitForm('ruleForm')">Next Step</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
import {freeGiftOrderFour} from '../../../api/freeGift'
export default {
    data() {
        // 邮箱验证
        var email = (rule, value, callback) => {
            // 邮箱正则
            const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
            // 邮箱框value判断
            if (!value) {
                callback(new Error('邮箱不能为空'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的邮件格式'))
            } else {
                callback()
            }
        }
        return {
             title:'',
            image:'',
            ruleForm:{
                address:'',
                amazonOrderId:'',
                email:'',
                name:'',
                phone:''
            },
            rules:{
                name: [
                   { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请填写地址', trigger: 'blur' }
                ],
                email: [
                    {required: true, validator: email, trigger: 'blur' }
                ]
            }
            
        }
    },
    methods:{
        submitForm(formName) {
            sessionStorage.share4address = this.ruleForm.address;
            sessionStorage.share4email = this.ruleForm.email;
            sessionStorage.share4name = this.ruleForm.name;
            sessionStorage.share4phone = this.ruleForm.phone;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    freeGiftOrderFour(this.ruleForm).then((res=>{
                        if (res.data.code === 200) {
                            this.$message.success(res.data.message);
                             this.$refs[formName].resetFields();
                            // 跳转到下一步
                            this.$router.push('/gift')
                        }else if(res.data.code === 201){
                            this.$router.push('/noOrderId')
                        } else {
                            this.$message(res.data.message);
                        }
                    }))
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.ruleForm.address = '';
            this.ruleForm.email = '';
            this.ruleForm.name = '';
            this.ruleForm.phone = '';
        },
        getValue(){
            var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
            if(!reg.test(this.ruleForm.phone)){
                alert("手机格式不正确");
            }
        }
    },
    created(){
        this.ruleForm.address = this.$route.query.address;
        this.ruleForm.amazonOrderId = this.$route.query.amazonOrderId;
        this.ruleForm.email = this.$route.query.email;
        this.ruleForm.name = this.$route.query.name;
        this.image = this.$route.query.image;
        this.title = this.$route.query.title;
        // this.ruleForm.remark = this.$route.query.remark;
        // this.ruleForm.url = this.$route.query.url;
         if(sessionStorage.share4address){
            this.ruleForm.address = sessionStorage.share4address;
        }
         if(sessionStorage.share4email){
            this.ruleForm.email = sessionStorage.share4email;
        }
        if(sessionStorage.share4name){
            this.ruleForm.name = sessionStorage.share4name;
        }
        if(sessionStorage.share4phone){
            this.ruleForm.phone = sessionStorage.share4phone;
        }
    },
    beforeRouteLeave(to,from,next){
      if(
          to.path == '/gift' || 
          to.path == '/warranty-activated' ||
          to.path == '/share-experience' ||
          to.path == 'share-experience-2' ||
          to.path == 'share-experience-3' ||
          to.path == 'share-experience-4'
          ){
            //缓存
          from.meta.keepAlive = true;
      }else{
            //不缓存
          from.meta.keepAlive = false ;
      }
      next()
  }
}
</script>
<style lang="less" scoped>
    .shareExperience{
        padding: 0px 30px;
        width: 70%;
        margin: 0 auto;
        padding-bottom: 50px;
        box-sizing: border-box;
       .step_title{
           margin-top: 20px;
           margin-bottom: 20px;
           p{
               font-size: 18px;
               color: #393838;
               line-height: 26px;
               margin-bottom: 10px;
               span{
                   color: #a099cb;
                   margin-right: 5px;
               }
           }
       }
       .post-content{
           display: flex;
        //    justify-content: space-around;
           margin-bottom: 30px;
           .post-content-left{
               width: 215px;
               margin-right: 4%;
               .fusion-title{
                   color: rgb(239, 129, 163);
                   font-size: 18px;
                   line-height: 26px;
                   font-weight: bold;
                   margin-bottom: 30px;
               }
               img{
                   width: 215px;
                   height: 215px;
               }
           }
           .el-card{
              width: 50%;
              margin-top: 20px;
           }
       }
    }
</style>